/**
 * Gegenstücke der Mitarbeiter-Bereiche auf beiden Geräteklassen — die Tabelle der Geräteweiche
 * in `app.component.ts` (`translateEmployeeArea`).
 *
 * Ohne diese Tabelle warf die Geräteweiche jeden Mitarbeiter auf die Startseite
 * zurück: Wer bei 1100px in „Meine Dokumente" stand und das Fenster auf 900px zog,
 * landete auf „Heute" — und beim Aufziehen wieder auf „Heute", nie zurück in den
 * Dokumenten. Bei acht Bereichen ist das acht Mal derselbe Verlust, offene
 * Formulare eingeschlossen. Windows-Snap auf halbe Breite eines 1920er-Schirms
 * trifft mit 960px genau die Kante.
 */
export const EMPLOYEE_AREA_EQUIVALENTS: ReadonlyArray<{ desktop: string; mobile: string }> = [
  { desktop: '/employee/dashboard/heute', mobile: '/employee-mobile/tabs/tab-today' },
  { desktop: '/employee/dashboard/schichten', mobile: '/employee-mobile/tabs/tab-my-shifts' },
  { desktop: '/employee/dashboard/zeiten', mobile: '/employee-mobile/tabs/tab-time-overview' },
  { desktop: '/employee/dashboard/aufgaben', mobile: '/employee-mobile/tabs/tab-tasks' },
  { desktop: '/employee/dashboard/abwesenheit', mobile: '/employee-mobile/tabs/tab-absences' },
  { desktop: '/employee/dashboard/verfuegbarkeit', mobile: '/employee-mobile/tabs/tab-availability' },
  { desktop: '/employee/dashboard/dokumente', mobile: '/employee-mobile/my-documents' },
  // Vor `profil`: der erste Treffer gewinnt, und `profil` allein schnitte die Unterseite ab — das
  // Glocken-Ziel „Meine Änderungsanträge“ (`?changeRequest=`) landete dann auf der Profilseite.
  { desktop: '/employee/dashboard/profil/change-requests', mobile: '/employee-mobile/profile/change-requests' },
  { desktop: '/employee/dashboard/profil', mobile: '/employee-mobile/profile' },
];

/**
 * Gegenstück einer Adresse auf der anderen Geräteklasse, `null` ohne Gegenstück.
 *
 * ⚠️ **Der Query-Teil reist mit** (P4, 17.10.2026): Glocken-/Push-Ziele hängen ihr Ziel als
 * `?absence=`, `?correction=`, `?swap=`, `?week=` an. Vorher schnitt die Weiche ihn ab — die Seite
 * ging auf, das Ziel war still verloren. Ein `#…` fällt weg (die App nutzt keine Fragmente).
 */
export function employeeAreaCounterpart(currentUrl: string | null | undefined, toMobile: boolean): string | null {
  const withoutHash = (currentUrl ?? '').split('#')[0];
  const queryIndex = withoutHash.indexOf('?');
  const path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : '';
  if (!path) return null;

  const match = EMPLOYEE_AREA_EQUIVALENTS.find((pair) => {
    const from = toMobile ? pair.desktop : pair.mobile;
    return path === from || path.startsWith(from + '/');
  });
  if (!match) return null;
  return (toMobile ? match.mobile : match.desktop) + (query === '?' ? '' : query);
}
